import React from "react";

interface FinalPriceSVGProps {
	text: string;
	width?: string | number;
	height?: string | number;
	fontSize?: string | number;
	color?: string;
	strokeColor?: string;
	shadowColor?: string;
	strokeWidth?: number;
	fontFamily?: string;
}

const FinalPriceSVG: React.FC<FinalPriceSVGProps> = ({
	text,
	width = "100%",
	fontSize = "2.2em",
	color = "#66cc32",
	strokeColor = "#fff",
	shadowColor = "rgba(0,0,0,0.35)",
	strokeWidth = 6,
	fontFamily = "Baloo, sans-serif"
}) => {
	return (
		<svg
			width={width}
			height={"3.8em"}
			style={{ display: "block", margin: "0 auto" }}
		>
			<filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
				<feDropShadow
					dx="0"
					dy="4"
					stdDeviation="2"
					floodColor={shadowColor}
					floodOpacity="1"
				/>
			</filter>
			<text
				x="50%"
				y="50%"
				textAnchor="middle"
				dominantBaseline="middle"
				fontFamily={fontFamily}
				fontSize={fontSize}
				fontWeight="400"
				fill={color}
				stroke={strokeColor}
				strokeWidth={strokeWidth}
				filter="url(#shadow)"
			>
				{text}
			</text>
		</svg>
	);
};

export default FinalPriceSVG;
